import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {toast} from "react-toastify";
import FreigabeDialog from "../../components/betriebsakte/betrieb/FreigabeDialog";
import EABetriebsakteDatenContainer from "../../components/betriebsakte/EABetriebsakteDatenContainer";
import EABetriebsakteMainContainer from "../../components/betriebsakte/EABetriebsakteMainContainer";
import EinleitstelleDaten from "../../components/betriebsakte/messstellen/EinleitstelleDaten";
import MessstellenDaten, {MessstelleZuordnenTableDialog} from "../../components/betriebsakte/messstellen/MessstellenDaten";
import MindestanforderungDaten from "../../components/betriebsakte/messstellen/MindestanforderungDaten";
import VorbelastungDaten from "../../components/betriebsakte/messstellen/VorbelastungDaten";
import {useConfirmation} from "../../components/ConfirmationDialog/ConfirmationDialogProvider";
import EAButtonBar from "../../components/EAButtonBar";
import EATabs from "../../components/EATabs";
import AuditInfoDialog from "../../components/historie/AuditInfoDialog";
import EAHistorySelector from "../../components/historie/EAHistorySelector";
import {INDUSTRIE} from "../../consts/betriebstyp";
import {ABGEWIESEN, BEANTRAGT, FREIGEGEBEN} from "../../consts/freigabestatus";
import {FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../consts/funktionaleRollen";
import {ENDKONTROLLMESSSTELLE} from "../../consts/messstellentyp";
import {
    calculateMessstelleLink,
    createEinleitstelleSchema,
    createInitialAnhangObject,
    createInitialMessstelle,
    createMessstelleSchema,
} from "../../initialObjects/MessstellenObjects";
import {handleApiException, isApiCancel, useHttp} from "../../services/HttpService";
import {logger} from "../../services/LogService";
import {
    getMessstelleEndpoint,
    getMessstelleFreigabeAnfordernEndpoint,
    getMessstelleFreigabeSetzenEndpoint,
    getMessstelleHistorieEndpoint,
    getMessstellenNrSuggestion,
    getMessstellennummerCheckEndpoint,
    getOberflaechenwasserkoerper,
    getTeileinzugsgebiet,
    putMessstelleEndpoint,
} from "../../services/Messstellenservice";
import {sortBy} from "../../utils/ArrayUtils";
import {createCalculatedColumn, createColumn} from "../../utils/ColumnUtils";
import {useForm} from "../../utils/FormUtils";
import {changeFieldValueIfPresent} from "../../utils/ObjectUtils";
import {userHasAnyRole} from "../../utils/SecurityUtils";
import {NUMBER, STRING} from "../../utils/URLUtils";
import usePathParam from "../../utils/usePathParam";
import useQueryParam from "../../utils/useQueryParam";
import {FACHOBJEKTSTATUS_GEPLANT} from "../../consts/fachobjektstatus";
import EAButton from "../../components/EAButton";
import EADialog from "../../components/EADialog";
import * as PropTypes from "prop-types";
import EATextField from "../../components/EATextField";

function MessstellennummerDialog(props) {
    const [messstellennummer1, setMessstellennummer1] = useState(props.suggestedId?.prefix);
    const [messstellennummer2, setMessstellennummer2] = useState(props.suggestedId?.frei);
    const [messstellennummer3, setMessstellennummer3] = useState(props.suffix);
    const [{
        data: nummerValid,
        loading: nummerValidLoading
    }, refetchMessstellennummerValid] = useHttp(getMessstellennummerCheckEndpoint(Number(buildMessstellennummer())));

    function buildMessstellennummer() {
        return "" + messstellennummer1 + messstellennummer2 + messstellennummer3;
    }

    function lengthValid() {
        return buildMessstellennummer().length === 10;
    }

    useEffect(() => {
        refetchMessstellennummerValid().then();
    }, [messstellennummer1, messstellennummer2, messstellennummer3, refetchMessstellennummerValid]);

    return (
        <EADialog
            open={props.open}
            titleChildren={"Messstellennummer festlegen"}
            content={
                <div style={{width: "300px", maxHeight: "200px"}}>
                    <div style={{paddingBottom: "10px"}}>
                        <span style={{color: "var(--primary-dark)", fontWeight: "bold"}}>Vorschlag Messstellennummer</span>
                    </div>
                    <div>
                        <EATextField
                            style={{width: "70px", display: "inline-block"}}
                            value={messstellennummer1}
                            onChange={(e) => {
                                if (e.target.value?.length <= 6 && !isNaN(e.target.value)) {
                                    setMessstellennummer1(e.target.value);
                                }
                                props.setMessstellennummer("" + e.target.value + messstellennummer2 + messstellennummer3);
                            }}
                            id="aufnahmeFilter"
                            data-cy="aufnahmeFilter"
                        />
                        <EATextField
                            style={{width: "40px", display: "inline-block"}}
                            value={messstellennummer2}
                            onChange={(e) => {
                                if (e.target.value?.length <= 2 && !isNaN(e.target.value)) {
                                    setMessstellennummer2(e.target.value);
                                }
                                props.setMessstellennummer("" + messstellennummer1 + e.target.value + messstellennummer3);
                            }}
                            id="aufnahmeFilter"
                            data-cy="aufnahmeFilter"
                        />
                        <EATextField
                            style={{width: "40px", display: "inline-block"}}
                            value={messstellennummer3}
                            onChange={(e) => {
                                if (e.target.value?.length <= 2 && !isNaN(e.target.value)) {
                                    setMessstellennummer3(e.target.value);
                                }
                                props.setMessstellennummer("" + messstellennummer1 + messstellennummer2 + e.target.value);
                            }}
                            id="aufnahmeFilter"
                            data-cy="aufnahmeFilter"
                        />

                        <div style={{height: "100%", display: "inline-block"}}>
                            {nummerValidLoading &&
                                <CircularProgress style={{height: "16px", width: "16px", marginTop: "9px", marginLeft: "5px"}}/>}
                            {!nummerValidLoading && nummerValid && lengthValid() &&
                                <div className={"ico-check"} style={{height: "16px", width: "16px", marginTop: "9px", marginLeft: "5px"}}/>}
                            {!nummerValidLoading && (!nummerValid || !lengthValid()) &&
                                <div className={"ico-kreuz"} style={{height: "16px", width: "16px", marginTop: "9px", marginLeft: "5px"}}/>}
                        </div>
                    </div>
                    <div style={{paddingTop: "1px"}}>
                        {nummerValidLoading && <span>Die Messstellennummer wird überprüft.</span>}
                        {!nummerValidLoading && nummerValid && lengthValid() &&
                            <span style={{color: "green"}}>Die Messstellennummer ist verfügbar.</span>}
                        {!nummerValidLoading && !nummerValid && lengthValid() &&
                            <span style={{color: "red"}}>Die Messstellennummer ist bereits vergeben.</span>}
                        {!nummerValidLoading && nummerValid && !lengthValid() &&
                            <span style={{color: "red"}}>Die Messstellennummer ist zu kurz.</span>}
                    </div>
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton id={"btnAbbrechen"} data-cy={"btnAbbrechen"} label={"Abbrechen"} onClick={props.onClickCancel}/>
                    <EAButton id={"btnVorschlag"} data-cy={"btnVorschlag"} label={"Vorschlag"} onClick={resetMessstellennummer}/>
                    <EAButton id={"btnOK"} data-cy={"btnOK"} label={"Speichern"} color="primary" onClick={props.onClickOk}
                              disabled={!nummerValid || !lengthValid()}/>
                </EAButtonBar>
            }
            closeFunction={props.onClickCancel}
        />
    );

    function resetMessstellennummer() {
        setMessstellennummer1(props.suggestedId?.prefix);
        setMessstellennummer2(props.suggestedId?.frei);
        setMessstellennummer3(props.suffix);
    }
}

MessstellennummerDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};

const tabMessstelle = "Messstelle";
const tabEinleitstelle = "Einleitstelle";
const tabMindestanforderung = "Mindestanforderungen";
const tabVorbelastungen = "Vorbelastungen";

function MessstellenDatenView({betriebstyp, reloadNavigation, modus, setToggleAllowed}) {
    const history = useHistory();
    const location = useLocation();
    const confirm = useConfirmation();
    const anlageId = usePathParam("anlageid", NUMBER);
    const messstellenId = usePathParam("messstellenid", NUMBER);
    const messstellentyp = useQueryParam("typ", STRING);
    const [selectedTab, setSelectedTab] = useState(tabMessstelle);
    const [tabOptions, setTabOptions] = useState([]);
    const [tabErrors, setTabErrors] = useState();
    const [freigabeDialogOpen, setFreigabeDialogOpen] = useState(false);
    const [freigabeKommentar, setFreigabeKommentar] = useState("");
    const [parentAnlage, setParentAnlage] = useState();
    const [{loading: oberflaechenwasserkoerperLoading}, refetchOberflaechenwasserkoerper] = useHttp("", {manual: true});
    const [{loading: teileinzugsgebietLoading}, refetchTeileinzugsgebiet] = useHttp("", {manual: true});
    const [{loading: messstelleLoading}, refetchMessstelle] = useHttp(getMessstelleEndpoint(messstellenId), {manual: true});
    const [{loading: nrSuggestionLoading}, refetchNrSuggestion] = useHttp("", {manual: true});
    const [messstellennummerDialogOpen, setMessstellennummerDialogOpen] = useState(false);
    const [customMessstellennummer, setCustomMessstellennummer] = useState();

    const {
        formFactory,
        values,
        setValues,
        submit,
        submitLoading,
        setSchema,
        errors,
        setErrors,
        touchedValues,
        setTouchedValues,
        validate,
        validateProperty,
    } = useForm({
        initialValues: {
            zugehoerigeBehoerden: []
        },
        readonly: modus !== "s",
    });

    // Historie
    const [auditInfoDialogOpen, setAuditInfoDialogOpen] = useState(false);
    const [auditInfoDialogViolation, setAuditInfoDialogViolation] = useState({art: "MISSING", faultyAuditInfo: {}});
    const [{data: historyData, loading: historyLoading}, refetchHistoryData] = useHttp(getMessstelleHistorieEndpoint(messstellenId), {
        manual: !messstellenId,
    });
    const [currentVersion, setCurrentVersion] = useState(null);

    const prevEinleitstelle = useRef();
    const prevLage = useRef();

    const [dlgMessstelleZuordnenOpen, setDlgMessstelleZuordnenOpen] = useState(false);

    const handleByTyp = useCallback(
        (typ) => {
            const newTabOptions = [tabMessstelle];

            let newSchema = createMessstelleSchema();
            if (typ) {
                if (typ === ENDKONTROLLMESSSTELLE) {
                    newSchema = {...newSchema, ...createEinleitstelleSchema()};
                    newTabOptions.push(tabEinleitstelle);
                }
            }

            if (betriebstyp.id === INDUSTRIE && typ === ENDKONTROLLMESSSTELLE) {
                newTabOptions.push(tabMindestanforderung, tabVorbelastungen);
            }

            setSelectedTab(tabMessstelle);
            setTabOptions(newTabOptions);
            setSchema(newSchema);
        },
        [setSchema, betriebstyp]
    );

    const setMessstelle = useCallback((valuesToSet) => {
        logger.debug("Geladene Messstelle", valuesToSet);
        valuesToSet.anhang = valuesToSet?.anhang ? valuesToSet.anhang : createInitialAnhangObject();
        if (valuesToSet.anhang && valuesToSet.anhang.anhangAbwasserverordnung) {
            valuesToSet.anhang.anhangAbwasserverordnung.value = valuesToSet.anhang.anhangAbwasserverordnung.bezeichnung;
        }
        if (valuesToSet.einleitstelle?.pegel) {
            valuesToSet.einleitstelle.pegel.bezeichnung = valuesToSet.einleitstelle.pegel.value;
        }
        setValues(valuesToSet);
        if (currentVersion === null) setCurrentVersion(_.cloneDeep(valuesToSet));
        handleByTyp(valuesToSet.messstellentyp.id);
    }, [currentVersion, handleByTyp, setValues]);

    useEffect(() => {
        prevEinleitstelle.current = null;
        if (!anlageId) {
            // Es dürfen keine Daten gesetzt werden, da die Werte noch nicht geladen sind
        } else if (messstellenId) {
            refetchMessstelle()
                .then(({data: valuesToSet}) => setMessstelle(valuesToSet));
            setErrors({});
        } else {
            setValues(createInitialMessstelle(messstellentyp));
            handleByTyp(messstellentyp);
            setErrors({});
        }
    }, [anlageId, messstellenId, messstellentyp, setValues, handleByTyp, refetchMessstelle, setMessstelle, currentVersion, setErrors,]);

    useEffect(() => {
        const newTabErrors = {};
        if (errors) {
            const errorKeys = Object.keys(errors);
            newTabErrors[tabEinleitstelle] = errorKeys.some((err) => err.startsWith("einleitstelle."));
            newTabErrors[tabMindestanforderung] = errorKeys.some((err) => err.startsWith("mindestanforderungen."));
            newTabErrors[tabVorbelastungen] = errorKeys.some((err) => err.startsWith("vorbelastungen."));
            newTabErrors[tabMessstelle] = errorKeys.some(
                (err) => !err.startsWith("einleitstelle.") && !err.startsWith("vorbelastungen.") && !err.startsWith("mindestanforderungen.")
            );
            setTabErrors(newTabErrors);
        }
        setTabErrors(newTabErrors);
    }, [errors]);

    // Falls der Messstellentyp "ENDKONTROLLMESSSTELLE" entspricht, muss der Rechts- und Hochwert der Lage
    // mit den Werten der Parentanlage vorbelegt werden
    useEffect(() => {
        const parentHasLage = values.lage?.rechtswert && values.lage?.hochwert;
        const einleitungHasLage = values.einleitstelle?.lage?.rechtswert && values.einleitstelle?.lage?.hochwert;
        const isEndkontrolle = messstellentyp === ENDKONTROLLMESSSTELLE;
        if (parentHasLage && !einleitungHasLage && isEndkontrolle && values.einleitstelle) {
            values.einleitstelle.lage = values.lage;
            setValues(values);
        }
    }, [messstellentyp, values, setValues]);

    useEffect(() => {
        if (values.einleitstelle?.lage?.hochwert && values.einleitstelle?.lage?.rechtswert) {
            if (
                values.einleitstelle.lage.hochwert === prevEinleitstelle.current?.hochwert &&
                values.einleitstelle.lage.rechtswert === prevEinleitstelle.current?.rechtswert
            ) {
                return;
            }
            prevEinleitstelle.current = {...values.einleitstelle.lage};

            refetchOberflaechenwasserkoerper(
                getOberflaechenwasserkoerper(prevEinleitstelle.current.hochwert, prevEinleitstelle.current.rechtswert)
            )
                .then((response) =>
                    setValues((oldVals) => {
                        return {
                            ...oldVals,
                            einleitstelle: {...oldVals.einleitstelle, oberflaechenwasserkoerper: response.data},
                        };
                    })
                )
                .catch((err) => {
                    if (isApiCancel(err)) {
                        return;
                    }
                    if (err.status === 204) {
                        setValues((oldVals) => {
                            return {
                                ...oldVals,
                                einleitstelle: {...oldVals.einleitstelle, oberflaechenwasserkoerper: null},
                            };
                        });
                    }
                });
            refetchTeileinzugsgebiet(getTeileinzugsgebiet(prevEinleitstelle.current.hochwert, prevEinleitstelle.current.rechtswert))
                .then((response) =>
                    setValues((oldVals) => {
                        return {
                            ...oldVals,
                            einleitstelle: {...oldVals.einleitstelle, teileinzugsgebiet: response.data},
                        };
                    })
                )
                .catch((err) => {
                    if (isApiCancel()) {
                        return;
                    }
                    if (err.status === 204) {
                        setValues((oldVals) => {
                            return {
                                ...oldVals,
                                einleitstelle: {...oldVals.einleitstelle, teileinzugsgebiet: null},
                            };
                        });
                    }
                });
        } else if (prevEinleitstelle.current) {
            if (teileinzugsgebietLoading) {
                refetchTeileinzugsgebiet({
                    url: "",
                    baseURL: "/",
                }).catch((e) => handleApiException(e, "Error loading Teileinzugsgebiet for Messstellendaten"));
            }
            if (oberflaechenwasserkoerperLoading) {
                refetchOberflaechenwasserkoerper({
                    url: "",
                    baseURL: "/",
                }).catch((e) => handleApiException(e, "Error loading Oberflaechenwasserkoerper for Messstellendaten"));
            }
            prevEinleitstelle.current = null;
            setValues({...values, einleitstelle: {...values.einleitstelle, oberflaechenwasserkoerper: null, teileinzugsgebiet: null}});
        }
    }, [
        values,
        prevEinleitstelle,
        setValues,
        refetchTeileinzugsgebiet,
        refetchOberflaechenwasserkoerper,
        teileinzugsgebietLoading,
        oberflaechenwasserkoerperLoading,
    ]);

    /**
     * Aktualisiert die MessstellenNr, wenn sich die Lage ändert
     */
    useEffect(() => {
        if (messstellenId) {
            return; //MessstellenNr muss nicht ermittelt werden da messstelle nicht neu ist
        }
        if (!messstellentyp || !values.lage?.hochwert || !values.lage?.rechtswert) {
            return; //es fehlen noch Angaben zum ermitteln einer MessstellenNr
        }
        if (values.lage.hochwert === prevLage.current?.hochwert && values.lage.rechtswert === prevLage.current?.rechtswert) {
            return; //Lage unverändert
        }
        prevLage.current = {...values.lage};
        refetchNrSuggestion(getMessstellenNrSuggestion(messstellentyp, prevLage.current.hochwert, prevLage.current.rechtswert))
            .then((response) => {
                    if (response.data) {
                        setValues((oldVals) => {
                            const fullNr = response.data.toString();
                            return {
                                ...oldVals,
                                suggestedId: {
                                    prefix: fullNr.substring(0, 6),
                                    frei: oldVals.suggestedId?.frei ? oldVals.suggestedId.frei : fullNr.substring(6, 8),
                                    suffix: fullNr.substring(8, 10),
                                },
                            };
                        })
                    }
                }
            )
            .catch((err) => {
                if (isApiCancel()) {
                    return;
                }
                if (err.status === 204) {
                    const msg = "Kombinationen Messtellen-Nr ausgeschöpft!";
                    toast.error(msg);
                    logger.error(msg);
                }
            });
    }, [values, setValues, messstellenId, messstellentyp, refetchNrSuggestion]);


    /**
     * Legt fest ob die Messstelle bearbeitet werden darf oder nicht
     */
    useEffect(() => {
        if (userHasAnyRole([SYSTEMADMIN, FACHADMIN])) {
            setToggleAllowed(true);
        } else if (userHasAnyRole([ZUST_SBD])) {
            if (!messstellenId) {     // Messstelle ist neu
                // anlegen erlauben
                setToggleAllowed(true);
            } else {                  // Messstelle ist nicht neu
                let freigabestatus = values?.freigabe?.status?.id;
                setToggleAllowed(freigabestatus === FREIGEGEBEN || freigabestatus === ABGEWIESEN);
            }
        } else {
            setToggleAllowed(false);
        }
    }, [values, setToggleAllowed, messstellenId]);

    // Update Statuswechsel, falls Status gewechselt wird
    useEffect(() => {
        if (touchedValues.messstellenstatus && !touchedValues.statuswechsel) {
            const newStatuswechselRequired = values.messstellenstatus?.id !== FACHOBJEKTSTATUS_GEPLANT;
            values.statuswechsel = newStatuswechselRequired ? new Date() : null;
            setValues(values);
        }
    }, [values, touchedValues, setValues]);

    function prepareForSubmit(valueCopy) {
        if (valueCopy.einleitstelle) {
            delete valueCopy.einleitstelle.oberflaechenwasserkoerper;
            delete valueCopy.einleitstelle.teileinzugsgebiet;
            changeFieldValueIfPresent(valueCopy.einleitstelle, "pegel", "id");
        }

        if (valueCopy.mindestanforderungen && valueCopy.mindestanforderungen.length > 0) {
            valueCopy.anhang.anhangAbwasserverordnung = valueCopy.mindestanforderungen[0].anhang;
            valueCopy.anhang.aox = valueCopy.mindestanforderungen[0].aox;
            valueCopy.anhang.bsb5 = valueCopy.mindestanforderungen[0].bsb5;
            valueCopy.anhang.cd = valueCopy.mindestanforderungen[0].cd;
            valueCopy.anhang.cr = valueCopy.mindestanforderungen[0].cr;
            valueCopy.anhang.csb = valueCopy.mindestanforderungen[0].csb;
            valueCopy.anhang.cu = valueCopy.mindestanforderungen[0].cu;
            valueCopy.anhang.gei = valueCopy.mindestanforderungen[0].gei;
            valueCopy.anhang.hg = valueCopy.mindestanforderungen[0].hg;
            valueCopy.anhang.id = valueCopy.mindestanforderungen[0].id;
            valueCopy.anhang.nges = valueCopy.mindestanforderungen[0].nges;
            valueCopy.anhang.nh4n = valueCopy.mindestanforderungen[0].nh4n;
            valueCopy.anhang.ni = valueCopy.mindestanforderungen[0].ni;
            valueCopy.anhang.pb = valueCopy.mindestanforderungen[0].pb;
            valueCopy.anhang.pges = valueCopy.mindestanforderungen[0].pges;

        }

        if (!valueCopy.anhang.anhangAbwasserverordnung || !valueCopy.anhang.abwasserart) {
            valueCopy.anhang = null;
        } else {
            changeFieldValueIfPresent(valueCopy.anhang, "abwasserart", "id");
        }
        changeFieldValueIfPresent(valueCopy, "messstellentyp", "id");
        changeFieldValueIfPresent(valueCopy, "messstellenstatus", "id");
        const suggestedId = valueCopy.suggestedId;
        if (!messstellenId && suggestedId) {
            if (customMessstellennummer) {
                valueCopy.messstellenId = customMessstellennummer;
            } else {
                valueCopy.messstellenId = "" + suggestedId.prefix + suggestedId.frei + suggestedId.suffix;
            }
            delete valueCopy.suggestedId;
        }
        if (parentAnlage) {
            valueCopy.abwasseranlage = parentAnlage.id;
        } else {
            valueCopy.abwasseranlage = null;
        }

        return valueCopy;
    }

    const requestAuditInfo = (violation) => {
        setAuditInfoDialogOpen(true);
        setAuditInfoDialogViolation(violation);
    };

    function toLeseModus(tmpMessstellenId) {
        if (location.pathname.indexOf(`/messstellen/${tmpMessstellenId}/messstellendaten/`) > -1) {
            const hasModus = location.search.indexOf("modus") > -1;
            if (modus === "s") {
                history.push(location.pathname + (hasModus ? _.replace(location.search, "modus=s", "modus=l") : "?modus=l"));
            } else {
                history.push(location.pathname + (hasModus ? _.replace(location.search, "modus=l", "modus=s") : "?modus=s"));
            }
        } else {
            history.replace(location.pathname.replace("neu", tmpMessstellenId) + "?modus=l");
        }
    }

    function saveAsAdmin(auditInfo = null, neuAnforderung = false) {
        submit(prepareForSubmit, putMessstelleEndpoint(messstellenId), "PUT", true, auditInfo)
            .then(() => {
                if (touchedValues.bezeichnung || touchedValues.messstellenstatus) {
                    reloadNavigation();
                }
                if (neuAnforderung) {
                    refetchMessstelle()
                        .then(({data: valuesToSet}) => setMessstelle(valuesToSet));
                }
                if (parentAnlage) {
                    refetchMessstelle()
                        .then(({data: valuesToSet}) => {
                            history.push(calculateMessstelleLink(valuesToSet));
                            reloadNavigation();
                            setParentAnlage(null);
                        });
                } else {
                    toLeseModus(messstellenId);
                }
                refetchHistoryData();
                toast.success("Die Messstelle wurde erfolgreich gespeichert.");
            })
            .catch((err) => {
                if (err?.response?.data?.auditInfoViolation) {
                    err.isValidationHandled = true;
                    requestAuditInfo(err?.response?.data);
                }
                if (!err.isValidationHandled) {
                    logger.error("Speichern einer Messstelle ist fehlgeschlagen: ", err);
                    toast.error("Das Speichern der Messstelle ist fehlgeschlagen!");
                }
            });
    }


    function freigabeAnfordern() {
        submit(prepareForSubmit, getMessstelleFreigabeAnfordernEndpoint(anlageId), "POST")
            .then((response) => {
                setMessstellennummerDialogOpen(false);
                toLeseModus(response.data.id);
                reloadNavigation();
                toast.success("Die Messstelle wurde erfolgreich angelegt.");
            })
            .catch((err) => {
                if (!err.isValidationHandled) {
                    logger.error("Freigabe einer Messstelle anfordern ist fehlgeschlagen: ", err);
                    toast.error("Das Anfordern der Freigabe der Messstelle ist fehlgeschlagen!");
                }
            });
    }

    function submitFreigabestatus(freigabestatus) {
        submit(prepareForSubmit, putMessstelleEndpoint(messstellenId), "PUT")
            .then(() => {
                setFreigabeDialogOpen(false);
                submit(
                    () => {
                        return {kommentar: freigabeKommentar, neuerStatus: freigabestatus};
                    },
                    getMessstelleFreigabeSetzenEndpoint(messstellenId),
                    "POST"
                ).then(() => {
                    if (touchedValues.bezeichnung) {
                        reloadNavigation();
                    }
                    if (freigabestatus === FREIGEGEBEN) {
                        const valuesToSet = {...values};
                        valuesToSet.freigabe.status.id = freigabestatus;
                        setValues(valuesToSet);
                    }
                    toLeseModus(messstellenId);
                    refetchMessstelle()
                        .then(({data: valuesToSet}) => setMessstelle(valuesToSet));
                    if (freigabestatus === FREIGEGEBEN) {
                        toast.success("Die Messstelle wurde erfolgreich freigegeben.");
                    } else {
                        toast.success("Die Messstelle wurde erfolgreich zurückgewiesen.");
                    }
                });
            })
            .catch((e) => {
                if (e?.response?.data?.auditInfoViolation) {
                    setFreigabeDialogOpen(false);
                    requestAuditInfo(e.response.data);
                } else if (!e.isValidationHandled) {
                    logger.error("Freigabe einer Messstelle ist fehlgeschlagen: ", e);
                    toast.error("Das Freigeben der Messstelle ist fehlgeschlagen! Alle anderen Änderungen wurden zuvor gespeichert.");
                }
            })
            .catch((err) => {
                if (!err.isValidationHandled) {
                    logger.error("Speichern einer Messstelle ist fehlgeschlagen: ", err);
                    toast.error("Beim Speichern vor der Freigabe der Messstelle ist ein Fehler aufgetreten!");
                }
            });
    }

    function freigabeBearbeitung(freigabestatus) {
        if (freigabestatus === ABGEWIESEN) {
            confirm({
                title: "Zurückweisung bestätigen",
                description: "Wollen Sie die Freigabe für die Messstelle wirklich zurückweisen?",
                onSubmit: () => {
                    submitFreigabestatus(freigabestatus);
                },
                onClose: () => {
                },
            });
        } else {
            submitFreigabestatus(freigabestatus);
        }
    }

    function calculateParentAnlage() {
        if (parentAnlage) {
            return parentAnlage.bezeichnung;
        }
        return "";
    };

    if (submitLoading || (messstellenId && messstelleLoading)) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress/>
            </div>
        );
    }

    function handleCloseMessstelleZuordnenDialog() {
        setDlgMessstelleZuordnenOpen(false);
    }

    function handleCloseMessstelleZuordnenDialogOk(anlage) {
        setDlgMessstelleZuordnenOpen(false);
        setParentAnlage(anlage);
    }

    function handleCloseMessstellennummerDialog() {
        setMessstellennummerDialogOpen(false);
    }

    function handleOpenMessstellennummerDialog() {
        let e = validate();
        if (!e) {
            setMessstellennummerDialogOpen(true);
        }
    }

    const backgroundColor = values.history ? {background: "#FFFFFF", filter: "sepia()"} : {};

    return (
        <EABetriebsakteMainContainer style={backgroundColor}>
            {auditInfoDialogOpen && (
                <AuditInfoDialog
                    open={auditInfoDialogOpen}
                    onClose={() => setAuditInfoDialogOpen(false)}
                    violation={auditInfoDialogViolation}
                    onAuditInfoSet={(aud) => saveAsAdmin(aud)}
                    onVerwerfen={() => {
                        setAuditInfoDialogOpen(false);
                        refetchMessstelle()
                            .then(({data: valuesToSet}) => setMessstelle(valuesToSet))
                            .catch((e) => handleApiException(e, "Error on AuditInfoDialog.onVerwerfen"));
                    }}
                />
            )}
            <FreigabeDialog
                label="Messstelle"
                open={freigabeDialogOpen}
                onClose={() => setFreigabeDialogOpen(false)}
                kommentar={freigabeKommentar}
                onKommentarChange={(newValue) => setFreigabeKommentar(newValue.currentTarget.value)}
                onAblehnen={() => freigabeBearbeitung(ABGEWIESEN)}
                onFreigabe={() => freigabeBearbeitung(FREIGEGEBEN)}
            />
            <EATabs
                value={selectedTab}
                onChange={(newSelectedTab) => setSelectedTab(newSelectedTab)}
                options={tabOptions}
                errors={tabErrors}
            />
            <EABetriebsakteDatenContainer>
                {selectedTab === tabMessstelle && (
                    <MessstellenDaten
                        formFactory={formFactory}
                        statusDisabled={!messstellenId || values?.freigabe?.status?.id !== FREIGEGEBEN}
                        data={values}
                        onChange={(name, data) => {
                            const valuesToSet = {...values};
                            _.set(valuesToSet, name, data);
                            setValues(valuesToSet);
                            const touchedValuesToSet = {...touchedValues};
                            _.set(touchedValuesToSet, name, true);
                            setTouchedValues(touchedValuesToSet);
                            setErrors(validateProperty(name, data));
                        }}
                        suggestedId={values.suggestedId}
                        nrSuggestionLoading={nrSuggestionLoading}
                        zustaendigeBehoerdenDisabled={messstellenId}
                        modus={modus}
                    />
                )}
                {selectedTab === tabEinleitstelle && (
                    <EinleitstelleDaten
                        formFactory={formFactory}
                        data={values}
                        onChange={(name, data) => {
                            const valuesToSet = {...values};
                            _.set(valuesToSet, name, data);
                            setValues(valuesToSet);
                            const touchedValuesToSet = {...touchedValues};
                            _.set(touchedValuesToSet, name, true);
                            setTouchedValues(touchedValuesToSet);
                            setErrors(validateProperty(name, data));
                        }}
                        oberflaechenwasserkoerperLoading={oberflaechenwasserkoerperLoading}
                        teileinzugsgebietLoading={teileinzugsgebietLoading}
                        modus={modus}
                    />
                )}
                {selectedTab === tabMindestanforderung && (
                    <MindestanforderungDaten
                        formFactory={formFactory}
                        mindestanforderungen={[values.anhang]}
                        currentAnhang={values.anhang?.anhangAbwasserverordnung}
                        onMindestanforderungenUpdate={(newMindestanforderungen) => {
                            const valuesToSet = {...values};
                            _.set(valuesToSet, "mindestanforderungen", newMindestanforderungen);
                            setValues(valuesToSet);
                        }}
                    />
                )}
                {selectedTab === tabVorbelastungen && (
                    <VorbelastungDaten
                        formFactory={formFactory}
                        vorbelastungen={sortBy(values.vorbelastungen, "gueltigAb")}
                        onVorbelastungenUpdate={(newVorbelastungen) => {
                            const valuesToSet = {...values};
                            _.set(valuesToSet, "vorbelastungen", newVorbelastungen);
                            setValues(valuesToSet);
                        }}
                    />
                )}
            </EABetriebsakteDatenContainer>
            <EAButtonBar
                style={{
                    marginTop: "var(--buttonBar-spacing-top)",
                    paddingLeft: "var(--horizontal-spacing)",
                    marginBottom: "var(--vertical-spacing)",
                    marginRight: "var(--horizontal-spacing)",
                }}
            >
                {messstellenId && modus === "l" &&
                    (selectedTab === tabMessstelle || selectedTab === tabEinleitstelle) && (
                        <div style={{flex: "max-content"}}>
                            <EAHistorySelector
                                data={historyData}
                                loading={historyLoading}
                                additionalColumns={[
                                    createColumn("bezeichnung", "Bezeichnung", {padding: "2px"}),
                                    createCalculatedColumn(
                                        "messstellenstatus",
                                        (row) => {
                                            return row?.messstellenstatus?.value;
                                        },
                                        "Status",
                                        {padding: "2px"}
                                    ),
                                ]}
                                onClickSelect={(row) => {
                                    if (modus === "s") history.push(location.pathname + _.replace(location.search, "modus=s", "modus=l"));
                                    if (row.timestamp !== "aktuell") setValues({...row, history: true});
                                    else setValues({...row});
                                }}
                                onCancel={() => setValues({...currentVersion})}
                            />
                        </div>
                    )}
                {dlgMessstelleZuordnenOpen && (
                    <MessstelleZuordnenTableDialog
                        open={dlgMessstelleZuordnenOpen}
                        onClickCancel={handleCloseMessstelleZuordnenDialog}
                        onClickOk={handleCloseMessstelleZuordnenDialogOk}
                        messstellenId={messstellenId}
                        anlageId={anlageId}
                        anlagentyp={"Abwasserbehandlung"}
                    />
                )}
                {modus === "s" && messstellenId && <div className="gridl" style={{gridTemplateColumns: "1fr auto", marginRight: "auto"}}>
                    {parentAnlage && formFactory.renderInputWithCustomDisplay("parentAnlage", "parentAnlage", "Neue Zuordnung", calculateParentAnlage, true)}
                    <EAButton id="edit-messstelle-button"
                              label={"Messstelle neu zuordnen"}
                              onClick={() => setDlgMessstelleZuordnenOpen(true)}
                    />
                </div>}
                {!messstellenId &&
                    userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    formFactory.renderButton("cancelCreate", "cancelCreate", "Abbrechen", () => history.goBack())}
                {!messstellenId &&
                    userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    formFactory.renderButton("freigabeAnfordern", "freigabeAnfordern", "Freigabe anfordern", handleOpenMessstellennummerDialog, {
                        color: "primary",
                        loading: nrSuggestionLoading,
                        disabled: nrSuggestionLoading,
                    })}
                {values?.freigabe?.status?.id === BEANTRAGT &&
                    userHasAnyRole([FACHADMIN, SYSTEMADMIN]) &&
                    formFactory.renderButton("editFreigabe", "editFreigabe", "Freigabe bearbeiten", () => setFreigabeDialogOpen(true), {
                        color: "primary",
                    })}
                {messstellenId &&
                    userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    formFactory.renderButton(
                        "saveMessstelleAsAdmin",
                        "saveMessstelleAsAdmin",
                        values?.freigabe?.status?.id === ABGEWIESEN ? "Freigabe erneut anfordern" : "Speichern",
                        (e) => {
                            e.preventDefault();
                            if (values?.freigabe?.status?.id === ABGEWIESEN) {
                                saveAsAdmin(null, true);
                            } else {
                                saveAsAdmin();
                            }
                        },
                        {
                            color: "primary",
                        }
                    )}
            </EAButtonBar>
            {messstellennummerDialogOpen && values.suggestedId && (
                <MessstellennummerDialog
                    open={messstellennummerDialogOpen}
                    onClickCancel={handleCloseMessstellennummerDialog}
                    onClickOk={freigabeAnfordern}
                    suggestedId={values.suggestedId}
                    suffix={getMessstellenIdSuffix()}
                    setMessstellennummer={setCustomMessstellennummer}
                />
            )}
        </EABetriebsakteMainContainer>
    );

    function getMessstellenIdSuffix() {
        if (values.suggestedId?.suffix) return values.suggestedId?.suffix;
        switch (messstellentyp) {
            case "NR_1":
                return "01";
            case "NR_2":
                return "02";
            case "NR_3":
                return "03";
            case "NR_4":
                return "04";
            case "NR_5":
                return "05";
            case "NR_6":
                return "06";
            case "NR_7":
                return "07";
            case "NR_8":
                return "08";
            case "NR_12":
                return "12";
            case "NR_13":
                return "13";
            case "NR_14":
                return "14";
            case "NR_15":
                return "15";
            default:
                return "xx";
        }
    }
}

export default MessstellenDatenView;
